import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { ButtonTertiary, IconButtonTertiary, } from '../../button/index.js';
import { nestedAction } from './nested-action.css.js';
import { Divider } from '../../divider/index.js';
export const NestedAction = ({ hideDivider, isVisible, isWrapped = false, size = 'small', type = 'icon', ...buttonProps }) => {
    const { className, ...otherProps } = buttonProps;
    return (isVisible && (_jsxs("div", { className: clsx([className, nestedAction({ isWrapped })]), children: [!isWrapped && !hideDivider && (_jsx(Divider, { orientation: "vertical", fixedSize: "24px" })), type === 'button' ? (_jsx(ButtonTertiary, { color: "subtle", size: size, ...otherProps })) : (_jsx(IconButtonTertiary, { color: "subtle", size: size, ...otherProps }))] })));
};
